<template lang="pug">
div
  .social_list__item.btn.btn--black(
    v-show='flixel.embedable || isOwner',
    :class='{faded: isOwner && !flixel.embedable}',
    @click='embedOpen()')
    | Embed
  .social_list__item.btn.btn--black#filterBtn(
    v-show='flixel.shareable || isOwner',
    :class='{faded: isOwner && !flixel.shareable}',
    @click='toggleSocial()')
    | Share
    ul
      li(@click='socialClick("facebook")')
        a(:href='"http://www.facebook.com/sharer/sharer.php?u=" + flixel.link') Facebook
      li(@click='socialClick("twitter")')
        a(:href='"https://twitter.com/share?url=" + flixel.link') Twitter
      li(@click='socialClick("email")')
        a(:href='"mailto:?subject=My Flixel&body=" + flixel.link') Email

  p.owner-warning(v-show='isOwner')
    i.fa.fa-info-circle
    span If embed or shared is greyed out, that means it will be hidden to other users.

  embed-popup(
    :embed='embed',
    :flixel='flixel')
</template>

<script>
import embedpopup from './EmbedPopup.vue';
import EventBus from '../eventBus.js';

export default {
  name: 'SocialSharing',
  props: ['flixel'],
  data() {
    return {
      isOwner: false,
      menuToggle: false,
      show: false,
      embed: '',
      embedShow: false,
      account: '',
    };
  },
  watch: {
    flixel(newVal) {
      this.account = JSON.parse(localStorage.getItem('account'));
      if (this.account !== null) {
        if (this.flixel.username === this.account.username) {
          this.isOwner = true;
        } else {
          this.isOwner = false;
        }
      }
    },
  },
  methods: {
    socialClick(provider) {
      ga('send', 'event', 'social-share', 'click-' + provider, this.flixel.username, this.flixel.id);
      if (provider === 'facebook') {
        let flixelHash;
        if (this.flixel) {
          flixelHash = this.flixel;
        } else {
          flixelHash = this.activeFlixel;
        }
        Facebook.api('https://graph.facebook.com/', 'post', {
          id: 'https://flixel.com/cinemagraph/' + flixelHash.hash,
          scrape: true,
        }, function (response) {
          console.log('rescrape!', response);
        });
      }
    },
    ownerHasHidden() {
      const disableShareOrEmbed = Boolean(!this.flixel.embedable || !this.flixel.shareable);
      return this.alwaysShowIfOwner && disableShareOrEmbed;
    },
    embedOpen() {
      EventBus.$emit('openEmbed');
    },
    toggleSocial() {
      $('#filterBtn ul').toggle();
    },
  },
  components: {
    'embed-popup': embedpopup,
  },
};
</script>




// WEBPACK FOOTER //
// src/components/SocialSharing.vue